export default __webpack_public_path__ + "static/media/recycle.47b42412.png";